import Badge from './Badge';

export default {
  id: 'blank_1',
  title: 'Blank_1',
  premium: true,
  colors: 1,
  BadgeComponentStateless: Badge
};
